export enum EFileStatusActionType {
    Edit,
    Reupload
  }

export class EFileStatusAction {
    static readonly Edit = new EFileStatusAction("fa-edit", EFileStatusActionType.Edit, (subType?: string) => subType ? (subType === "I" ? "NRC code required" : "IBAN/Identification code required") : "");
    static readonly ReUpload = new EFileStatusAction("fa-upload", EFileStatusActionType.Reupload, () => "Re-upload");

    private constructor(public readonly icon: string, public readonly type: EFileStatusActionType, public readonly tooltip: Function) {

    }
}


